import config from '../config'
import { authHeader } from './auth-header'

export const customerService = {
  getAll, addNewCustomer, updateCustomer,getInvoices,getAccountTransactions
}

function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/all`, requestOptions).then(handleResponse)
}

function addNewCustomer (customer) {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(customer),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/create`, requestOptions).then(handleResponse)
}

function getInvoices (customerId) {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({customerId:customerId}),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/invoices`, requestOptions).then(handleResponse)
}

function getAccountTransactions (customerId) {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({customerId:customerId}),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/accountTransactions`, requestOptions).then(handleResponse)
}



function updateCustomer (customer) {
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(customer),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/customers/update`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout()
        // location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
